import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';

// Cache for the configured loader to avoid re-initializing DRACO
let dracoLoader = null;

/**
 * Creates a GLTFLoader configured with DRACOLoader support
 * @returns {GLTFLoader} Configured GLTFLoader instance
 */
export const createGLTFLoader = () => {
  const loader = new GLTFLoader();
  
  // Initialize DRACOLoader if not already done
  if (!dracoLoader) {
    dracoLoader = new DRACOLoader();
    // Use jsdelivr CDN for DRACO decoder files (reliable and commonly used)
    // This serves the decoder files from the three.js npm package
    dracoLoader.setDecoderPath('https://cdn.jsdelivr.net/npm/three@0.162.0/examples/jsm/libs/draco/gltf/');
  }
  
  // Set the DRACO loader on the GLTF loader
  loader.setDRACOLoader(dracoLoader);
  
  return loader;
};
